import { render, staticRenderFns } from "./transDialog.vue?vue&type=template&id=9f371d60&scoped=true"
import script from "./transDialog.vue?vue&type=script&lang=js"
export * from "./transDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f371d60",
  null
  
)

export default component.exports